const searchPlaceHolder: any = {
  users: "Search by first name, last name or email",
  roles: "Search by name",
  organizations: "Search by name",
  employee: "Search by name, email id, employee code or phone number",
  process: "Search by name",
  team: "Search by name",
  costcenter: "Search by name",
  zone: "Search by name",
  commonpoint: "Search by name",
  requests: "Search by name",
  vendors: "Search by name",
  cab: "Search cabs by registration number or model",
  driver: "Search drivers by name or license number",
  "event-logs": "Search by description, module, action or updated by"
};
export default searchPlaceHolder;
